import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Service } from "../../../types/providerTypes";

interface ServiceState {
  services: Service[];
  loading: boolean;
  error: string | null;
}

const initialState: ServiceState = {
  services: [],
  loading: false,
  error: null,
};

const serviceSlice = createSlice({
  name: "service",
  initialState,
  reducers: {
    startLoading(state) {
      state.loading = true;
      state.error = null;
    },
    endLoading(state) {
      state.loading = false;
    },
    setServices(state, action: PayloadAction<Service[]>) {
      state.services = action.payload;
      state.loading = false;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const serviceActions = serviceSlice.actions;
export default serviceSlice;
